<template>
  <div>
    <CCard>
      <CCardHeader>
        <h5>Массовая генерация промокодов</h5>
      </CCardHeader>
      <CCardBody>
        <AppFormValidator
          ref="validator"
          #default="{ errors }"
          :model="model"
          :rules="rules"
        >
          <CForm @submit.prevent>
            <CInput
              v-model="model.count"
              horizontal
              label="Количество промокодов"
              placeholder="Введите количество промокодов (макс. 1000)"
              :is-valid="errors.count && errors.count.isValid"
            />

            <CInput
              v-model="model.length"
              horizontal
              label="Длина промокода (от 8 до 12 символов)"
              placeholder="Введите длину промокода (от 8 до 12 символов)"
              :is-valid="errors.length && errors.length.isValid"
            />

            <CInput
              v-model="model.description"
              horizontal
              label="Описание"
              placeholder="Введите краткое описание промокодов"
              :is-valid="errors.description && errors.description.isValid"
              :invalid-feedback="errors.description && errors.description.message"
            />

            <CInput
              v-model="model.min_sum"
              horizontal
              label="Минимальная сумма заказа"
              placeholder="Введите минимальную сумму заказа"
              :is-valid="errors.min_sum && errors.min_sum.isValid"
            />

            <!-- Добавленные поля для выбора сервисов -->
            <CRow
                v-if="allRestaurants"
                form
                class="form-group">
                <CCol
                    tag="label"
                    class="col-form-label"
                    sm="3"> Рестораны </CCol>
                <CCol sm="9">
                    <div>
                        <CInputCheckbox
                            :checked.sync="model.all_restaurants"
                            label="Все рестораны"
                            class="font-bold"
                        />
                    </div>
                    <div class="flex flex-wrap">
                        <div
                            v-for="restaurant in allRestaurants"
                            :key="restaurant.id"
                            class="w-1/4"
                        >
                            <CInputCheckbox
                                :checked.sync="restaurantsSelected[restaurant.id]"
                                :label="restaurant.title"
                                :disabled="model.all_restaurants"
                            />
                        </div>
                    </div>
                </CCol>
            </CRow>

            <CRow
                v-if="allGrocers"
                form
                class="form-group">
                <CCol
                    tag="label"
                    class="col-form-label"
                    sm="3">
                    Магазины продуктов
                </CCol>
                <CCol sm="9">
                    <div>
                        <CInputCheckbox
                            :checked.sync="model.all_grocers"
                            label="Все магазины продуктов"
                            class="font-bold"
                        />
                    </div>
                    <div class="flex flex-wrap">
                        <div
                            v-for="grocer in allGrocers"
                            :key="grocer.id"
                            class="w-1/4">
                            <CInputCheckbox
                                :checked.sync="grocersSelected[grocer.id]"
                                :label="grocer.title"
                                :disabled="model.all_grocers"
                            />
                        </div>
                    </div>
                </CCol>
            </CRow>

            <div v-if="entityTypes">
                <CRow
                    v-for="type in entityTypes"
                    :key="type.id"
                    form
                    class="form-group">
                    <CCol
                        tag="label"
                        class="col-form-label"
                        sm="3"> {{ type.title }} </CCol>
                    <CCol sm="9">
                        <div>
                            <CInputCheckbox
                                :checked.sync="entityTypesSelected[type.id]"
                                :label="`Все сервисы «${type.title}»`"
                                class="font-bold"
                                @change="disableEntity($event, type.code)"
                            />
                        </div>
                        <div v-if="type.services && type.services.length" class="flex flex-wrap">
                            <div
                                v-for="entity in type.services"
                                :key="entity.id"
                                class="w-1/4"
                            >
                                <CInputCheckbox
                                    :checked.sync="entitiesSelected[entity.id]"
                                    :label="entity.title"
                                    :disabled="disabledEntities[type.code]"
                                />
                            </div>
                        </div>
                    </CCol>
                </CRow>
            </div>

            <CRow class="mb-2 mt-6" :class="{ 'is-invalid': dateErrors.dateFrom }">
              <CCol
                tag="label"
                class="col-form-label"
                sm="3">
                Дата начала: <span class="text-danger">*</span>
              </CCol>
              <CCol class="p-0 ml-2" sm="3">
                <DatePicker
                  v-model="datepicker.dateFrom"
                  :language="datepicker.lang"
                  :format="datepicker.format"
                  :input-class="['form-control', 'custom-datepicker', { 'is-invalid': dateErrors.dateFrom }]"
                  placeholder="Выберите дату..."
                  @selected="dateErrors.dateFrom = false"
                />
                <span v-if="dateErrors.dateFrom" class="invalid-feedback d-block">Обязательное поле</span>
              </CCol>
            </CRow>
            <CRow class="mb-6" :class="{ 'is-invalid': dateErrors.dateTo }">
              <CCol
                tag="label"
                class="col-form-label"
                sm="3">
                Дата окончания: <span class="text-danger">*</span>
              </CCol>
              <CCol class="p-0 ml-2" sm="3">
                <DatePicker
                  v-model="datepicker.dateTo"
                  :language="datepicker.lang"
                  :format="datepicker.format"
                  :input-class="['form-control', 'custom-datepicker', { 'is-invalid': dateErrors.dateTo }]"
                  placeholder="Выберите дату..."
                  @selected="dateErrors.dateTo = false"
                />
                <span v-if="dateErrors.dateTo" class="invalid-feedback d-block">Обязательное поле</span>
              </CCol>
            </CRow>
            <CRow class="pl-3 mb-4">
              <CButton
                color="light"
                class="mr-3"
                @click="resetDate"
              >Сброс дат</CButton>
            </CRow>

            <CInput
              v-model="model.term_day"
              horizontal
              label="Время жизни промокода (в днях)"
              placeholder="Введите количество дней"
            />

            <CInput
              v-model="model.term_count"
              horizontal
              label="Количество заказов (разрешенное)"
              placeholder="Введите количество заказов"
              :is-valid="errors.term_count && errors.term_count.isValid"
            />

            <CInput
              v-model="model.max_term_count_for_user"
              horizontal
              label="Сколько максимально заказов может быть у пользователя, чтобы он смог применить промокод (0 - новички без заказов, 10000 - все смогут применить)"
              placeholder="Введите количество заказов"
              :is-valid="errors.max_term_count_for_user && errors.max_term_count_for_user.isValid"
            />

            <CInput
              v-model="model.min_term_count_for_user"
              horizontal
              label="Сколько минимально заказов должно быть у пользователя, чтобы он смог применить промокод"
              placeholder="Введите количество заказов"
              :is-valid="errors.min_term_count_for_user && errors.min_term_count_for_user.isValid"
            />

            <CInput
              v-model="model.discount_percent"
              horizontal
              label="Размер скидки (%)"
              placeholder="Введите размер скидки (%)"
              :is-valid="errors.discount_percent && errors.discount_percent.isValid"
            />

            <CInput
              v-model="model.discount_sum"
              horizontal
              label="Размер скидки (руб.)"
              placeholder="Введите размер скидки (руб.)"
              :is-valid="errors.discount_sum && errors.discount_sum.isValid"
            />
            <CRow form class="form-group">
              <CCol sm="3" />
              <CCol sm="9">
                <small class="form-text text-muted"><span class="text-danger">*</span> Обязательно заполните одно из полей: скидка в % или в руб.</small>
              </CCol>
            </CRow>

            <!-- Новые поля -->
            <CInput
              v-model="model.entity_discount_percent"
              horizontal
              label="Размер скидки от ресторана (%)"
              placeholder="Введите размер скидки от ресторана (%)"
              :is-valid="errors.entity_discount_percent && errors.entity_discount_percent.isValid"
            />

            <CInput
              v-model="model.entity_discount_sum"
              horizontal
              label="Размер скидки от ресторана (руб.)"
              placeholder="Введите размер скидки от ресторана (руб.)"
              :is-valid="errors.entity_discount_sum && errors.entity_discount_sum.isValid"
            />

            <CInput
              v-model="model.mircity_commission"
              horizontal
              label="Размер комиссии МИРСИТИ (%)"
              placeholder="Введите размер комиссии МИРСИТИ (%)"
              :is-valid="errors.mircity_commission && errors.mircity_commission.isValid"
            />

            <CRow form class="form-group">
              <CCol
                tag="label"
                class="col-form-label"
                sm="3">
                Отправлять в интеграции (скидка от партнера)
              </CCol>
              <CCol sm="9">
                <CSwitch
                  class=""
                  color="success"
                  shape="pill"
                  variant="opposite"
                  :checked.sync="model.accounting_in_integration"
                />
              </CCol>
            </CRow>

            <CRow form class="form-group">
              <CCol
                tag="label"
                class="col-form-label"
                sm="3">
                Бесплатная доставка
              </CCol>
              <CCol sm="9">
                <CSwitch
                  class=""
                  color="success"
                  shape="pill"
                  variant="opposite"
                  :checked.sync="model.free_delivery"
                />
              </CCol>
            </CRow>

            <CRow form class="form-group">
              <CCol
                tag="label"
                sm="3"
                class="col-form-label">Тип доставки</CCol>
              <CCol sm="9">
                <CSelect
                  inline
                  :value.sync="model.delivery_type"
                  :options="delivery_types"
                  placeholder="Тип доставки..."
                />
              </CCol>
            </CRow>

            <CRow form class="form-group">
              <CCol
                tag="label"
                class="col-form-label"
                sm="3"> Включено </CCol>
              <CCol sm="9">
                <CSwitch
                  class=""
                  color="success"
                  shape="pill"
                  variant="opposite"
                  :checked.sync="model.enabled"
                />
              </CCol>
            </CRow>

            <div class="flex mt-4">
              <CButton
                color="primary"
                @click="generate"
              >Сгенерировать
              </CButton>
            </div>
          </CForm>
        </AppFormValidator>

        <div v-if="generatedCodes.length" class="mt-4">
          <CCard>
            <CCardHeader>
              <div class="d-flex justify-content-between align-items-center">
                <h5>Сгенерированные промокоды ({{ generatedCodes.length }})</h5>
                <div>
                  <CButton
                    color="success"
                    class="mr-2"
                    @click="copyToClipboard"
                  >
                    Копировать в буфер
                  </CButton>
                  <CButton
                    color="primary"
                    @click="downloadCSV"
                  >
                    Скачать CSV
                  </CButton>
                </div>
              </div>
            </CCardHeader>
            <CCardBody>
              <div class="code-container">
                <div
                  v-for="(code, index) in generatedCodes"
                  :key="index"
                  class="code-item"
                >
                  {{ code }}
                </div>
              </div>
            </CCardBody>
          </CCard>
        </div>
      </CCardBody>
    </CCard>
  </div>
</template>

<script>
import to from 'await-to-js';
import DatePicker from 'vuejs-datepicker';
import moment from 'moment';
import { ru } from 'vuejs-datepicker/dist/locale';
import { requiredRule } from '@/utils/rules';
import AppFormValidator from '@/components/AppFormValidator';
const { DELIVERY_TYPE } = require('@/utils/order');

export default {
  name: 'PromocodeMassGeneration',
  components: {
    AppFormValidator,
    DatePicker
  },
  data() {
    return {
      model: {
        count: 100,
        length: 8,
        description: '',
        min_sum: 0,
        term_count: 1,
        max_term_count_for_user: null,
        min_term_count_for_user: null,
        discount_percent: 0,
        discount_sum: 0,
        entity_discount_percent: 0,
        entity_discount_sum: 0,
        mircity_commission: 0,
        free_delivery: false,
        accounting_in_integration: false,
        all_restaurants: false,
        all_grocers: false,
        type: 'mass',
        enabled: true,
        delivery_type: null
      },
      rules: {
        count: [requiredRule],
        length: [requiredRule],
        description: [requiredRule],
        min_sum: [requiredRule],
        term_count: [requiredRule]
      },
      datepicker: {
        lang: ru,
        format: 'dd.MM.yyyy',
        dateFrom: null,
        dateTo: null
      },
      dateErrors: {
        dateFrom: false,
        dateTo: false
      },
      generatedCodes: [],
      // Данные для выбора сервисов
      allRestaurants: [],
      allGrocers: [],
      entityTypes: [],
      restaurantsSelected: {},
      grocersSelected: {},
      entityTypesSelected: {},
      entitiesSelected: {},
      disabledEntities: {},
      delivery_types: null
    };
  },
  watch: {
    'model.discount_percent'(val) {
      if (val !== null && val !== '' && Number(val) !== 0) {
        this.model.discount_sum = 0;
        this._clearDiscountErrors();
      }
    },
    'model.discount_sum'(val) {
      if (val !== null && val !== '' && Number(val) !== 0) {
        this.model.discount_percent = 0;
        this._clearDiscountErrors();
      }
    }
  },
  created() {
    this.initBusiness();
    this.initDeliveryTypes();
  },
  methods: {
    resetDate() {
      this.datepicker.dateFrom = null;
      this.datepicker.dateTo = null;
      this.dateErrors.dateFrom = false;
      this.dateErrors.dateTo = false;
    },

    _clearDiscountErrors() {
      if (this.$refs.validator && this.$refs.validator.errors) {
        this.$set(this.$refs.validator.errors, 'discount_percent', { isValid: true, message: '' });
        this.$set(this.$refs.validator.errors, 'discount_sum', { isValid: true, message: '' });
      }
    },

    initDeliveryTypes() {
      const types = [];
      types.push({ value: DELIVERY_TYPE.DOOR, label: 'До двери' });
      types.push({ value: DELIVERY_TYPE.MEETING_POINT, label: 'Место встречи' });
      types.push({ value: DELIVERY_TYPE.WITHOUT, label: 'Без доставки' });
      types.push({ value: DELIVERY_TYPE.COLLECT, label: 'Сборка заказа' });
      types.push({ value: null, label: 'Без типа доставки' });
      this.delivery_types = types;
    },

    async initBusiness() {
      try {
        // Restaurants
        this.allRestaurants = (await this.axios.get('/restaurants')).data;
        // Grocers
        this.allGrocers = (await this.axios.get('/grocers')).data;
        // Entities
        this.entityTypes = (await this.axios.get('/entities-type')).data;
        this.entityTypes = await Promise.all(this.entityTypes.map(async type => {
          this.disabledEntities[type.code] = false;
          type.services = (await this.axios.get(`/entities/${type.code}`)).data;
          return type;
        }));
        this.initBusinessSelected();
      } catch (err) {
        this.$root.$emit('showError', 'Ошибка при загрузке данных сервисов');
        console.error(err);
      }
    },

    initBusinessSelected() {
      // Restaurants
      this.allRestaurants.sort((a, b) => a.title > b.title ? 1 : -1);
      if (this.allRestaurants.length) {
        for (const restaurant of this.allRestaurants) {
          this.restaurantsSelected[restaurant.id] = false;
        }
      }
      
      // Grocers
      this.allGrocers.sort((a, b) => a.title > b.title ? 1 : -1);
      if (this.allGrocers.length) {
        for (const grocer of this.allGrocers) {
          this.grocersSelected[grocer.id] = false;
        }
      }
      
      // Entities
      this.entityTypes.sort((a, b) => a.title > b.title ? 1 : -1);
      if (this.entityTypes.length) {
        for (const type of this.entityTypes) {
          this.entityTypesSelected[type.id] = false;
        }
        
        for (const type of this.entityTypes) {
          for (const entity of type.services) {
            this.entitiesSelected[entity.id] = false;
          }
        }
      }
    },

    disableEntity(value, typeCode) {
      this.disabledEntities[typeCode] = value;
    },

    async generate() {
      const [error] = await to(this.$refs.validator.validate());

      if (error) {
        const descriptionError = error.errors.find(e => e.field === "description");
        if(descriptionError) {
          this.$root.$emit('showError', 'Введите краткое описание промокодов');
        }
        // const message = error.errors && error.errors.length
        //   ? error.errors.map(e => e.message).join('. ')
        //   : 'Проверьте заполнение полей';
        // this.$root.$emit('showError', message);
        return false;
      }

      if (this.dateErrors.dateFrom || this.dateErrors.dateTo) {
        this.$root.$emit('showError', 'Заполните даты начала и окончания');
        return false;
      }

      this.dateErrors.dateFrom = !this.datepicker.dateFrom;
      this.dateErrors.dateTo = !this.datepicker.dateTo;
      if (this.dateErrors.dateFrom || this.dateErrors.dateTo) {
        this.$root.$emit('showError', 'Заполните даты начала и окончания');
        return false;
      }

      const hasDiscount = (this.model.discount_percent != null && this.model.discount_percent !== '' && Number(this.model.discount_percent) !== 0) ||
        (this.model.discount_sum != null && this.model.discount_sum !== '' && Number(this.model.discount_sum) !== 0);
      if (!hasDiscount) {
        const msg = 'Заполните одно из полей: скидка в % или в руб.';
        this.$root.$emit('serverValidationErrors', {
          discount_percent: msg,
          discount_sum: msg
        });
        this.$root.$emit('showError', msg);
        return false;
      }

      const payload = { ...this.model };
      
      // Add dates
      payload.date_start = this.datepicker.dateFrom ? moment(Date.parse(this.datepicker.dateFrom)).toISOString() : null;
      payload.date_finish = this.datepicker.dateTo ? moment(Date.parse(this.datepicker.dateTo)).toISOString() : null;

      // Добавление выбранных сервисов
      payload.restaurants = [];
      payload.grocers = [];
      payload.entity_types = [];
      payload.entities = [];

      // Рестораны
      if (!payload.all_restaurants) {
        Object.keys(this.restaurantsSelected).forEach(id => {
          if (this.restaurantsSelected[id]) {
            payload.restaurants.push(+id);
          }
        });
      }

      // Магазины продуктов
      if (!payload.all_grocers) {
        Object.keys(this.grocersSelected).forEach(id => {
          if (this.grocersSelected[id]) {
            payload.grocers.push(+id);
          }
        });
      }



      // Типы сервисов и сервисы
      Object.keys(this.entityTypesSelected).forEach(typeId => {
        if (this.entityTypesSelected[typeId]) {
          payload.entity_types.push(+typeId);
        }
      });

      Object.keys(this.entitiesSelected).forEach(entityId => {
        if (this.entitiesSelected[entityId]) {
          payload.entities.push(+entityId);
        }
      });
      
      payload.max_term_count_for_user = payload.max_term_count_for_user ? +payload.max_term_count_for_user : null;
      payload.min_term_count_for_user = payload.min_term_count_for_user ? +payload.min_term_count_for_user : null;
      payload.entity_discount_percent = payload.entity_discount_percent ? +payload.entity_discount_percent : null;
      payload.entity_discount_sum = payload.entity_discount_sum ? +payload.entity_discount_sum : null;
      payload.mircity_commission = payload.mircity_commission ? +payload.mircity_commission : null;
      payload.term_day = payload.term_day ? +payload.term_day : null;
      payload.delivery_type = payload.delivery_type ? +payload.delivery_type : null;

      try {
        const { data } = await this.axios.post('/promocodes/mass-generate', payload);
        if (data && data.promocodes) {
          this.generatedCodes = data.promocodes;
          this.$root.$emit('showSuccess', `Успешно сгенерировано ${data.promocodes.length} промокодов`);
        }
      } catch (err) {
        this.$root.$emit('showError', 'Ошибка при генерации промокодов');
        console.error(err);
      }
    },

    copyToClipboard() {
      const text = this.generatedCodes.join('\n');
      navigator.clipboard.writeText(text)
        .then(() => {
          this.$root.$emit('showSuccess', 'Промокоды скопированы в буфер обмена');
        })
        .catch(() => {
          this.$root.$emit('showError', 'Не удалось скопировать в буфер обмена');
        });
    },

    downloadCSV() {
      const csvContent = this.generatedCodes.join('\n');
      const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
      const link = document.createElement('a');
      
      const now = new Date();
      const filename = `promocodes_${now.getFullYear()}-${(now.getMonth() + 1).toString().padStart(2, '0')}-${now.getDate().toString().padStart(2, '0')}.csv`;
      
      if (navigator.msSaveBlob) { // IE 10+
        navigator.msSaveBlob(blob, filename);
      } else {
        const url = URL.createObjectURL(blob);
        link.href = url;
        link.setAttribute('download', filename);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    }
  }
};
</script>

<style scoped>
.code-container {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  max-height: 300px;
  overflow-y: auto;
}

.code-item {
  background-color: #f8f9fa;
  border: 1px solid #dee2e6;
  border-radius: 4px;
  padding: 5px 10px;
  font-family: monospace;
  font-size: 14px;
}

input.custom-datepicker {
  padding: 0.375rem 0.75rem;
  border-radius: 0.25rem;
  border: 1px solid;
  border-color: #d8dbe0;
  width: 100%;
}
</style> 